import { createFileRoute } from '@tanstack/react-router';
import NotFound from '@src/pages/NotFound';

import { getLocalizedTitle } from '../title';

export const Route = createFileRoute('/_app/$')({
  head: () => ({
    meta: [{ title: getLocalizedTitle('common.not_found', 'Not Found') }],
  }),
  component: NotFound,
});
